import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { indexParagraphRevealAnimation } from './animations'
import { Section, WPLink } from '@/types'

type IndexParagraphProps = Section &
  Partial<{
    subtitle: string
    subtitle_component: TypographyProps['component']
    paragraph: string
    button: WPLink
  }>

const IndexParagraph = ({
  subtitle,
  subtitle_component,
  paragraph,
  ...props
}: IndexParagraphProps) => {
  return (
    <Motion animation={indexParagraphRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-sm">
              <div className="col-span-2 md:col-span-3 lg:col-span-6">
                {subtitle ? (
                  <Typography
                    variant="subtitle"
                    component={subtitle_component}
                    className="font-inter font-bold uppercase text-white [&_em]:text-blue-soft"
                    data-motion-subtitle
                  >
                    {subtitle}
                  </Typography>
                ) : null}
              </div>
              <div className="col-span-2 md:col-span-3 lg:col-span-6">
                {paragraph ? (
                  <Typography
                    variant="body"
                    className="block text-white/80"
                    data-motion-paragraph
                  >
                    {paragraph}
                  </Typography>
                ) : null}
              </div>
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default IndexParagraph
